// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'

// Internal Dependencies:
import ContentBox from 'components/ContentBox/ContentBox'

class Resources extends React.Component {
	renderResourceCategories = () => {
		const { page } = this.props

		if ( ! page ) {
			return null
		}

		const resourceCategoriesMarkup = page.resource_categories.map( ( e, i ) => {
			let className = e.image_url ? '-with-resource-image -with-link' : '-with-link'

			return (
				<article className="tile" key={ i }>
					<ContentBox
						url={ e.url }
						headerIcon="icon-folder-o"
						footerTitle={ e.title }
						className={ className }
						image={ e.image_url }
						imageClass="-resource-image"
					/>
				</article>
			)
		})

		if ( ! resourceCategoriesMarkup.length ) {
			return null
		}

		return (
			<div className="resources tiles">
				<div className="-area -wrap">
					{ resourceCategoriesMarkup }
				</div>
			</div>
		)
	}

	renderResources = () => {
		const { page } = this.props

		if ( ! page ) {
			return null
		}

		const resourcesTileClass = page.resource_tiles_with_content ? 'tile -col-12' : 'tile'
		const resourcesMarkup = page.resources.map( ( e, i ) => {
			let icon = e.is_category ? 'icon-folder-o' : 'icon-file-o'
			icon = e.is_download ? 'icon-download' : icon
			icon = e.is_external_link ? 'icon-external-link' : icon

			if ( page.resource_tiles_with_content ) {
				return (
					<article className={ resourcesTileClass } key={ i }>
						<ContentBox
							mainHeading={ e.title }
							className="-with-resource-image"
							image={ e.image_url }
							imageClass="-resource-image"
							mainText={ e.content }
						/>
					</article>
				)
			} else {
				let className = e.image_url ? '-with-resource-image -with-link' : '-with-link'

				return (
					<article className={ resourcesTileClass } key={ i }>
						<ContentBox
							url={ e.url }
							headerIcon={ icon }
							footerTitle={ e.title }
							className={ className }
							image={ e.image_url }
							imageClass="-resource-image"
						/>
					</article>
				)
			}
		})

		if ( ! resourcesMarkup.length ) {
			return null
		}

		const resourcesClass = page.resource_tiles_with_content ? 'resources tiles tiles-with-content' : 'resources tiles'

		return (
			<div className={ resourcesClass }>
				<div className="-area -wrap">
					{ resourcesMarkup }
				</div>
			</div>
		)
	}

	render() {
		const { page } = this.props

		if ( ! page ) {
			return null
		}

		const resourceCategories = this.renderResourceCategories()
		const resources = this.renderResources()

		if ( ! resourceCategories && ! resources ) {
			return null
		}

		return (
			<div className="section-resources">
				<div className="-inner">
					{ resourceCategories }
					{ resources }
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		page: state.page.selected
	}
}

const mapDispatchToProps = ( dispatch, ownProps ) => {
	return {

	}
}

export default connect( mapStateToProps, mapDispatchToProps )( Resources )
